import React from 'react'
import styled from 'styled-components'
import uniqid from 'uniqid'
import { FaCheck } from 'react-icons/fa'

export const Container = styled.div`
  width: ${props => props.width ? props.width : '100%'};
  position: relative;

  & label {
    font-size: 14px;
    font-family: 'Open Sans';
    font-weight: 600;
    padding-left: 25px;
    line-height: 18px;
    display: ${props => props.display ? props.display : 'block'};
    color: #222;
    cursor: pointer;


    svg {
      position: absolute;
      left: 3px;
      top: 3px;
      visibility: hidden;
    }
  }

  & label:before {
    display: block;
    content: '';
    position: absolute;
    width: 18px;
    height: 18px;
    border: 2px solid #555;
    left: 0;
    top: 0;
    border-radius: 4px;
  }

  & label:after {
    display: block;
    content: '';
    position: absolute;
    width: 18px;
    height: 18px;
    border: 2px solid #01878E;
    left: 0;
    top: 0;
    opacity: 0;
    border-radius: 4px;
  }

  input:checked ~ label {

    &:after {
      opacity: 1;
    }

    &:before {
      background-color: #01878E;
    }

    svg {
      visibility: visible;
    }
  }

  input:disabled ~ label {
    opacity: 0.5;
  }
`

export const InputStyled = styled.input`
  display: none;
`

export const ErrorMessage = styled.p`
  color: #ff0000;
  font-size: 13px;
  font-family: 'Open Sans';
  font-weight: 400;
  margin: 0px;
`

const Checkbox = ({ display, width, label, defaultChecked, name, onChange, checked, errorMessage }) => {
  const id = uniqid()
  const hasError = !!errorMessage
  return (
    <>
      <Container display={display} width={width} >
        <InputStyled
          id={id}
          name={name}
          type='checkbox'
          defaultChecked={defaultChecked}
          checked={checked}
          onChange={onChange}
        />
        <label htmlFor={id}>
          {label}
          <FaCheck size='12' color='#fff' />
        </label>
        {hasError && (<ErrorMessage>{errorMessage}</ErrorMessage>)}
      </Container>
    </>
  )
}

export default Checkbox
